import React from 'react';

import AnalysisEbayResultsSection from './AnalysisEbayResultsSection';
import AnalysisImageGallery from './AnalysisImageGallery';
import AnalysisItemsList from './AnalysisItemsList';
import AnalysisResultMetaBadges from './AnalysisResultMetaBadges';

const AnalysisResultsSection = ({
  analysisResult,
  modelName,
  useEbayRag,
  useNotesRag,
  assumeHiddenItems,
  analysisDisplayImageUrls,
  currentImageIndex,
  onChangeCurrentImageIndex,
  colors,
  onOpenModal,
  onMarkResultImageError,
  originalPrices,
  originalNames,
  updatingId,
  updatingNameId,
  onManualNameChange,
  onUpdateItemName,
  onPriceChange,
  onUpdatePrice,
  ebayLoading,
  ebayResults,
}) => {
  const items = Array.isArray(analysisResult?.items) ? analysisResult.items : [];

  return (
    <div className="mt-4 sm:mt-8">
      <h3 className="text-lg sm:text-xl font-semibold text-slate-800 mb-2 sm:mb-3">Analysis Results:</h3>
      <div className="p-3 sm:p-6 bg-slate-50 rounded-lg border border-slate-200">
        <AnalysisResultMetaBadges
          analysisResult={analysisResult}
          modelName={modelName}
          useEbayRag={useEbayRag}
          useNotesRag={useNotesRag}
          assumeHiddenItems={assumeHiddenItems}
        />

        <div className="flex flex-col md:flex-row gap-4 sm:gap-6">
          <AnalysisImageGallery
            analysisDisplayImageUrls={analysisDisplayImageUrls}
            currentImageIndex={currentImageIndex}
            onChangeCurrentImageIndex={onChangeCurrentImageIndex}
            items={items}
            colors={colors}
            onOpenModal={onOpenModal}
            onMarkResultImageError={onMarkResultImageError}
          />
          <AnalysisItemsList
            items={items}
            currentImageIndex={currentImageIndex}
            originalPrices={originalPrices}
            originalNames={originalNames}
            updatingId={updatingId}
            updatingNameId={updatingNameId}
            onManualNameChange={onManualNameChange}
            onUpdateItemName={onUpdateItemName}
            onPriceChange={onPriceChange}
            onUpdatePrice={onUpdatePrice}
          />
        </div>

        <AnalysisEbayResultsSection
          ebayLoading={ebayLoading}
          ebayResults={ebayResults}
        />
      </div>
    </div>
  );
};

export default AnalysisResultsSection;
